import moment from 'moment'
export default {
  async created() {
    await this.$store.dispatch('getHolidays', {
      from: moment().format('YYYY-MM'),
      to: moment().add(1, 'months').format('YYYY-MM')
    })
      .catch(error => this.$log_error(error.message) )
      .finally(() => {
        this.$store.dispatch('setMinPproposalsDate', this.$store.getters['getNewTender']?.scheduledStart)
      })

  },
}
